import React from "react"
import { Container, Typography, Grid } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { GatsbyImage } from "gatsby-plugin-image"

const KundenSectionStyle = theme => ({
  root: {
    paddingTop: theme.spacing(8),
  },
  gridList: {
    marginTop: theme.spacing(4),
  },
  gridTile: {
    //border: "solid 1px lightgrey",

    "& img": {
      [theme.breakpoints.down("md")]: {
        height: "50px",
        width: "auto",
      },

      filter: "grayscale(100%)",
      "&:hover": {
        filter: "none",
      },
    },
  },
})

const useStyles = makeStyles(KundenSectionStyle)

export default function KundenSection({ kunden }) {
  const classes = useStyles()
  return (
    <Container maxWidth="lg" className={classes.root} component="section">
      <Typography variant="h2">Our Clients</Typography>
      <Grid container className={classes.gridList} space={3}>
        {kunden.map(({ node: { id }, node: { frontmatter } }) => (
          <Grid item key={id} className={classes.gridTile}>
            {(frontmatter?.website ?? false) === false ? (
              <GatsbyImage
                image={frontmatter.images[0].childImageSharp.gatsbyImageData}
                alt={frontmatter.title}
                title={frontmatter.title}
              />
            ) : (
              <a href={frontmatter.website} target="_blank" rel="noreferrer">
                <GatsbyImage
                  image={frontmatter.images[0].childImageSharp.gatsbyImageData}
                  alt={frontmatter.title}
                  title={frontmatter.title}
                />
              </a>
            )}
          </Grid>
        ))}
      </Grid>
    </Container>
  )
}
